import { render, staticRenderFns } from "./TopUpAmount.vue?vue&type=template&id=1e48f79c&scoped=true&"
import script from "./TopUpAmount.vue?vue&type=script&lang=js&"
export * from "./TopUpAmount.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAmount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TopUpAmount.vue?vue&type=style&index=1&id=1e48f79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48f79c",
  null
  
)

export default component.exports